package com.github.jangalinski.tabweb.card

import com.github.jangalinski.tabweb._foundation.css.cssClass

internal data object CardCss {
  const val CLASS = "card"

  val CARD = cssClass(CLASS)
  val CARD_HEADER = cssClass("$CLASS-header")
  val CARD_HEADER_LIGHT = cssClass("$CLASS-header-light")
  val CARD_HEADER_TABS = cssClass("$CLASS-header-tabs")
  val CARD_HEADER_PILLS = cssClass("$CLASS-header-pills")
  val CARD_TITLE = cssClass("$CLASS-title")
  val CARD_SUBTITLE = cssClass("$CLASS-subtitle")
  val CARD_BODY = cssClass("$CLASS-body")
  val CARD_BODY_SCROLLABLE = cssClass("$CLASS-body-scrollable")
  val CARD_FOOTER = cssClass("$CLASS-footer")
  val CARD_FOOTER_TRANSPARENT = cssClass("$CLASS-footer-transparent")
  val CARD_FOOTER_BORDERLESS = cssClass("$CLASS-footer-borderless")
  val CARD_ACTIONS = cssClass("$CLASS-actions")
  val CARD_STATUS_TOP = cssClass("$CLASS-status-top")
  val CARD_STATUS_BOTTOM = cssClass("$CLASS-status-bottom")
  val CARD_STATUS_START = cssClass("$CLASS-status-start")
  val CARD_STATUS_END = cssClass("$CLASS-status-end")
  val CARD_STAMP = cssClass("$CLASS-stamp")
  val CARD_STAMP_ICON = cssClass("$CLASS-stamp-icon")
  val CARD_STAMP_LG = cssClass("$CLASS-stamp-lg")
  val CARD_PROGRESS = cssClass("$CLASS-progress")
  val CARD_LINK = cssClass("$CLASS-link")
  val CARD_LINK_ROTATE = cssClass("$CLASS-link-rotate")
  val CARD_LINK_POP = cssClass("$CLASS-link-pop")
  val CARD_ROTATE_START = cssClass("$CLASS-rotate-start")
  val CARD_ROTATE_END = cssClass("$CLASS-rotate-end")
  val CARD_ROTATE_LEFT = cssClass("$CLASS-rotate-left")
  val CARD_ROTATE_RIGHT = cssClass("$CLASS-rotate-right")
  val CARD_ACTIVE = cssClass("$CLASS-active")
  val CARD_INACTIVE = cssClass("$CLASS-inactive")
  val CARD_BORDERLESS = cssClass("$CLASS-borderless")
  val CARD_STACKED = cssClass("$CLASS-stacked")
  val CARD_SM = cssClass("$CLASS-sm")
  val CARD_MD = cssClass("$CLASS-md")
  val CARD_LG = cssClass("$CLASS-lg")
  val CARD_GROUP = cssClass("$CLASS-group")
  val CARD_TABS = cssClass("$CLASS-tabs")
  val CARD_TABS_BOTTOM = cssClass("$CLASS-tabs-bottom")
  val CARD_IMG_TOP = cssClass("$CLASS-img-top")
  val CARD_IMG_BOTTOM = cssClass("$CLASS-img-bottom")
  val CARD_IMG_START = cssClass("$CLASS-img-start")
  val CARD_IMG_END = cssClass("$CLASS-img-end")
  val CARD_IMG = cssClass("$CLASS-img")
  val CARD_IMG_OVERLAY = cssClass("$CLASS-img-overlay")

  val RIBBON = cssClass("ribbon")
  val RIBBON_TOP = cssClass("ribbon-top")
  val RIBBON_BOTTOM = cssClass("ribbon-bottom")
  val RIBBON_START = cssClass("ribbon-start")
  val RIBBON_END = cssClass("ribbon-end")
  val RIBBON_BOOKMARK = cssClass("ribbon-bookmark")
}
